import { IContactDetailsState } from '@r1-frontend/entities/ContactDetail/initialState';

export const isPersonDataFilled = (state: IContactDetailsState): boolean => {
    const {
        contactDetails: {
            editedPhone,
            editedFio,
        },
    } = state;

    return Boolean(editedFio) && Boolean(editedPhone);
};
